import axios from 'axios'
import { config } from 'config'
import {
  requestAuthMiddleware,
  requestScenarioSelectorMiddleware,
  responseMiddlewareSuccess,
  responseMiddlewareError,
} from '../middlewares'

const isEnableMock = process.env.REACT_APP_ENABLE_MOCK

const { surpriseApiUrl } = config.apiGateway
const surpriseApi = axios.create({
  baseURL: surpriseApiUrl,
})

surpriseApi.interceptors.request.use(requestAuthMiddleware)

if (isEnableMock) {
  surpriseApi.interceptors.request.use(requestScenarioSelectorMiddleware)
}

surpriseApi.interceptors.response.use(
  responseMiddlewareSuccess,
  responseMiddlewareError,
)

export { surpriseApi }
